import React from 'react';
import styled from 'styled-components';

import { Row } from '../Row';
import { StepCounter } from '../StepCounter';
import { BackButton } from './BackButton';
import { CloseButton } from './CloseButton';
import { Logo } from '../../svg';

import { breakpoints, spacing } from '../../constants';

interface IProps {
    className?: string;
    closeButtonOnly?: boolean;
    stepNumber?: number;
    greyTheme?: boolean;
    totalSteps: number;
    onBackButtonClick?(): void;
    onCloseButtonClick?(): void;
}

const BaseAppHeader = ({
    className,
    closeButtonOnly,
    stepNumber,
    greyTheme,
    onBackButtonClick,
    onCloseButtonClick,
    totalSteps,
}: IProps) => (
    <div className={className}>
        <Logo />
        <Row>
            {!closeButtonOnly && (
                <BackButton
                    backgroundGrey={greyTheme}
                    helpText="Vorige"
                    onClick={onBackButtonClick}
                />
            )}
            {!closeButtonOnly && stepNumber && (
                <StepCounter
                    step={stepNumber}
                    totalSteps={totalSteps}
                    backgroundGrey={greyTheme}
                />
            )}
            <CloseButton
                backgroundGrey={greyTheme}
                helpText="Sluiten"
                onClick={onCloseButtonClick}
            />
        </Row>
    </div>
);

export const AppHeader = styled(BaseAppHeader)`
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 1;

    ${Row} {
        justify-content: space-between;
        align-items: center;
        padding: 20px;

        @media (${breakpoints.mediumMin}) {
            justify-content: ${({ closeButtonOnly }) =>
                closeButtonOnly && 'flex-end'};
        }
    }

    ${Logo} {
        display: none;

        @media (${breakpoints.mediumMin}) {
            display: block;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);
            width: 14%;
            max-width: 240px;
            min-width: 180px;
            height: auto;
        }
    }

    ${CloseButton} {
        margin-left: auto;

        @media (${breakpoints.mediumMin}) {
            order: 3;
            margin-left: 0;
        }
    }

    ${BackButton} {
        margin-right: auto;

        @media (${breakpoints.mediumMin}) {
            order: 2;
            margin-right: ${spacing.xl};
        }
    }

    ${StepCounter} {
        @media (${breakpoints.mediumMin}) {
            margin-right: auto;
        }
    }
`;
